module.exports = __webpack_public_path__ + "img/4.74fa805d.png";